import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './FirstPartyModal.scss';
import TableModal from '../../../../../common/Modal/TableModal/TableModal';
import Icon from '../../../../../common/Icon/Icon';
import Tooltip from '../../../../../common/Tooltip/Tooltip';
import { isDmpRecentSegment } from '../../../../../../utils/segmentUtils';

const FirstPartyModal = ({
  isOpen,
  modalTitle,
  firstPartySegments = [],
  firstPartyInput = {},
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const type = '1st party';

  const transformedData = useMemo(
    () =>
      firstPartySegments.map((segment) => ({
        segmentValue: segment?.dmp_segment_id,
        createdAt: segment?.created_at,
        name: segment?.name,
        sourceName: segment?.first_party_source_name,
        segmentSize: segment?.segment_size?.toLocaleString(),
        createdBy: segment?.created_by,
        segment: segment,
      })),
    [firstPartySegments]
  );

  const renderDiscoveryUsers = (row) => (
    <div className="discovery-users-container">
      <span>{row.segmentSize}</span>
      {isDmpRecentSegment(row.segment) && (
        <Tooltip
          options={{ theme: 'grey' }}
          content="This segment was created recently. User counts may take a few days to stabilize."
        >
          <Icon iconId="info-italic" className="info-icon" />
        </Tooltip>
      )}
    </div>
  );
  renderDiscoveryUsers.displayName = 'renderDiscoveryUsers';

  const columns = [
    {
      id: 'name',
      title: 'Segment',
      sortable: true,
      showTooltip: true,
      className: 'cell-name',
    },
    {
      id: 'createdAt',
      title: 'Created On',
      sortable: true,
      className: 'cell-date',
    },
    {
      id: 'sourceName',
      title: 'Source',
      sortable: true,
      className: 'cell-name',
    },
    {
      id: 'segmentSize',
      title: 'Discovery Users',
      sortable: true,
      className: 'cell-number',
      template: renderDiscoveryUsers,
    },
    {
      id: 'segmentValue',
      title: 'DMP Segment ID',
      sortable: true,
      className: 'cell-id',
    },
  ];

  const handleRowClick = (row) => {
    if (onSubmit) {
      const selectedSegment = {
        ...firstPartyInput,
        type,
        ...row.segment,
      };
      onSubmit(selectedSegment);
    }
  };

  return (
    <div className="first-party-modal-component">
      <TableModal
        isOpen={isOpen}
        modalTitle={modalTitle}
        subtitle="Select a segment by clicking its row"
        data={transformedData}
        columns={columns}
        onRowClick={handleRowClick}
        onCancel={onCancel}
        searchPlaceholder="Search first party segments..."
        emptyMessage="No first party segments found"
        searchableFields={['name', 'sourceName', 'segmentValue']}
        defaultSort={{ key: 'createdAt', direction: 'desc' }}
        width="700"
        height="527px"
        isLoading={isLoading}
      />
    </div>
  );
};

FirstPartyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string,
  firstPartySegments: PropTypes.array,
  firstPartyInput: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default FirstPartyModal;
